import { Button } from '@mui/material';
import { TabsProps } from 'antd';
import OverlayPanelWrapper from 'components/Overlays/OverlayPanelWrapper';
import HolidayConfiguration from 'features/configuration/components/HolidayConfiguration';
import PeakSeasonAddEditPanel from 'features/configuration/components/PeakSeasonAddEditPanel/PeakSeasonAddEditPanel';
import PeakSeasonConfiguration from 'features/configuration/components/PeakSeasonConfiguration/PeakSeasonConfiguration';
import React, { ReactNode } from 'react';

export enum PEAK_SEASON_CONFIG_TYPE {
  PEAK_SEASON = 'peak-season',
  HOLIDAY = 'holiday',
}

export const tabItems: TabsProps['items'] = [
  {
    key: PEAK_SEASON_CONFIG_TYPE.PEAK_SEASON,
    label: 'Mùa cao điểm',
  },
  {
    key: PEAK_SEASON_CONFIG_TYPE.HOLIDAY,
    label: 'Ngày lễ',
  },
];

export const pageActions: Partial<Record<PEAK_SEASON_CONFIG_TYPE, ReactNode>> =
  {
    [PEAK_SEASON_CONFIG_TYPE.PEAK_SEASON]: (
      <div className="flex items-center gap-x-4">
        <OverlayPanelWrapper
          renderOverlayPanel={(open, setOpen) => (
            <PeakSeasonAddEditPanel open={open} setOpen={setOpen} />
          )}
        >
          <Button>Thêm cao điểm bán</Button>
        </OverlayPanelWrapper>
      </div>
    ),
  };

export const tabContent: Partial<Record<PEAK_SEASON_CONFIG_TYPE, ReactNode>> = {
  [PEAK_SEASON_CONFIG_TYPE.PEAK_SEASON]: <PeakSeasonConfiguration />,
  [PEAK_SEASON_CONFIG_TYPE.HOLIDAY]: <HolidayConfiguration />,
};
